import type { LayerUnion } from "@/layers";

export type IsoInputField = "values" | "value_range" | "isoband_intervals";

export type IsoPatchArgs = {
  field: IsoInputField;
  rawValue: string;
  withIsobandIntervals: boolean;
  currentCustomOptions?: unknown;
};

export const normalizeIsoInput = (value: string): string | null => {
  return value.trim().length ? value : null;
};

export const asObject = (value: unknown): Record<string, unknown> => {
  if (typeof value === "object" && value !== null) {
    return value as Record<string, unknown>;
  }
  return {};
};

export const toInputValue = (value?: string | null): string => {
  return value ?? "";
};

export function getInitialIsoInputField(args: {
  withIsobandIntervals: boolean;
  values?: string | null;
  valueRange?: string | null;
  isobandIntervals?: string | null;
}): IsoInputField | null {
  if (args.withIsobandIntervals && normalizeIsoInput(args.isobandIntervals ?? "")) {
    return "isoband_intervals";
  }
  if (normalizeIsoInput(args.values ?? "")) {
    return "values";
  }
  if (normalizeIsoInput(args.valueRange ?? "")) {
    return "value_range";
  }
  return null;
}

export function buildIsoSelectionPatch(args: IsoPatchArgs): Partial<LayerUnion> {
  const selectedValue = normalizeIsoInput(args.rawValue);

  if (!args.withIsobandIntervals) {
    if (args.field === "values") {
      return {
        values: selectedValue,
        value_range: null,
      };
    }
    return {
      values: null,
      value_range: selectedValue,
    };
  }

  const customOptions = asObject(args.currentCustomOptions);
  if (args.field === "isoband_intervals") {
    return {
      values: null,
      value_range: null,
      custom_options: {
        ...customOptions,
        isoband_intervals: selectedValue,
      },
    };
  }

  return {
    values: args.field === "values" ? selectedValue : null,
    value_range: args.field === "value_range" ? selectedValue : null,
    custom_options: {
      ...customOptions,
      isoband_intervals: null,
    },
  };
}
